import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSaleOrdTrackingData } from '../../Store/PHPSlice/Tracking/AllTracking';
import { selectSOTrackingData } from '../Selectors/TrackSelector/TrackSelector';
import '../../Static/PHPStatic/Tracking.css';

const SOTracking = () => {
    const dispatch = useDispatch();
    const soTrack = useSelector(selectSOTrackingData);
    useEffect(() => {
        dispatch(fetchSaleOrdTrackingData());
    }, []);


    const handleClothIssue = (id) => {
        window.open(`/ClothIssueView/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const handleCuttingView = (id) => {
        window.open(`/CuttingFinalPrint/${id}`, '_blank', 'width=1300,height=700,scrollbars=yes,resizable=yes');
    }

    const handleStitchView = (id) => {
        window.open(`/StitchReturnInfo/${id}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };


    const handleKajeView = (id) => {
        window.open(`/KajeProductionInfo/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    const handlePackingView = (id) => {
        window.open(`/packing-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    return (
        <>
            <div className="main-b">
                <h3>Sale Order Tracking</h3>

                <table>
                    <thead>
                        <th>Sr.No.</th>
                        <th>Sale Order No.</th>
                        <th>Item</th>
                        <th>Current Status</th>
                        <th>Cloth Issue</th>
                        <th>Cutting</th>
                        <th>Numbering</th>
                        <th>Fusioning</th>
                        <th>Stitching</th>
                        <th>Kaje</th>
                        <th>Trimming</th>
                        <th>Pressing</th>
                        <th>Stock</th>
                        <th>Packing</th>
                    </thead>
                    <tbody>
                        {soTrack?.data?.map?.((item, index) => (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item?.sono}</td>
                                <td>{item?.itemNm}</td>
                                <td>{item?.current_stage}</td>
                                <td style={{ cursor: 'pointer' }} onClick={() => handleClothIssue(item.clothIssueId)}>{item?.is_issued}</td>
                                <td style={{ cursor: 'pointer' }} onClick={() => handleCuttingView(item.cutId)}>{item?.is_cutting_done}</td>
                                <td style={{ cursor: 'pointer' }}>{item?.is_numbering_done}</td>
                                <td style={{ cursor: 'pointer' }}>{item?.is_fusioning_done}</td>
                                <td style={{ cursor: 'pointer' }} onClick={() => handleStitchView(item.stichId)}>{item?.is_stitched}</td>
                                <td style={{ cursor: 'pointer' }} onClick={() => handleKajeView(item.kajeId)}>{item?.is_kaje_done}</td>
                                <td style={{ cursor: 'pointer' }}>{item?.is_trimming_done}</td>
                                <td style={{ cursor: 'pointer' }}>{item?.is_pressing_done}</td>
                                <td style={{ cursor: 'pointer' }}>{item?.is_stocked}</td>
                                <td style={{ cursor: 'pointer' }} onClick={() => handlePackingView(item.packId)}>{item?.is_packing_done}</td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </>
    );
}

export default SOTracking;
